import { ManualIncomeStatus } from '@/types'

export type ManualPayCycleDecision = 'approve' | 'reject'

// The proto calls an approved request SUCCESS; support staff think of it as approved.
export const MANUAL_INCOME_STATUS_LABEL: Record<ManualIncomeStatus, string> = {
  UNSPECIFIED: 'Unknown',
  PENDING: 'Pending',
  SUCCESS: 'Approved',
  REJECTED: 'Rejected',
}

export const MANUAL_INCOME_STATUS_COLOUR: Record<ManualIncomeStatus, string> = {
  UNSPECIFIED: '#344054',
  PENDING: '#B54708',
  SUCCESS: '#067647',
  REJECTED: '#B42318',
}
